<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MlbbSeriesTabs',
  props: {
    slots: {
      type: Array,
      default: () => []
    },
    activeGameNumber: {
      type: Number,
      default: 1
    },
    hostGroupTeamId: {
      type: Number,
      default: null
    },
    guestGroupTeamId: {
      type: Number,
      default: null
    },
    hostTeamName: {
      type: String,
      default: ''
    },
    guestTeamName: {
      type: String,
      default: ''
    }
  },
  computed: {
    tabs() {
      return (this.slots || []).map((slot) => ({
        ...slot,
        isActive: slot.game_number === this.activeGameNumber,
        winnerName: this.winnerName(slot.winner_group_team_id)
      }))
    }
  },
  methods: {
    winnerName(winnerId) {
      if (winnerId == null) return ''
      if (this.hostGroupTeamId != null && winnerId === this.hostGroupTeamId) return this.hostTeamName
      if (this.guestGroupTeamId != null && winnerId === this.guestGroupTeamId) return this.guestTeamName
      return ''
    },
    handleClick(tab) {
      this.$emit('select', tab.game_number)
    }
  }
})
</script>

<template>
  <div class="series-tabs">
    <button
        v-for="tab in tabs"
        :key="`series-tab-${tab.game_number}`"
        type="button"
        class="series-tab"
        :class="[
          `series-tab--${tab.status}`,
          { 'is-active': tab.isActive }
        ]"
        @click="handleClick(tab)"
    >
      <span class="series-tab__label">
        <span
            v-if="tab.status === 'completed'"
            class="series-tab__icon series-tab__icon--completed"
            aria-hidden="true"
        >✓</span>
        <span
            v-else-if="tab.status === 'current'"
            class="series-tab__icon series-tab__icon--current"
            aria-hidden="true"
        >●</span>
        Игра {{ tab.game_number }}
      </span>
      <span class="series-tab__title">
        <template v-if="tab.status === 'completed'">
          <template v-if="tab.winnerName">Победа {{ tab.winnerName }}</template>
          <template v-else>Завершена</template>
        </template>
        <template v-else-if="tab.status === 'current'">Текущая игра</template>
        <template v-else-if="tab.status === 'waiting'">Ожидание</template>
        <template v-else-if="tab.status === 'not_needed'">Не потребовалась</template>
      </span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.series-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 16px;
}

.series-tab {
  min-width: 140px;
  padding: 8px 14px;
  border-radius: 10px;
  border: 2px solid transparent;
  background: #fff;
  color: #495057;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }

  &__label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
  }

  &__icon {
    font-size: 12px;
    line-height: 1;
  }

  &__title {
    font-size: 13px;
    font-weight: 700;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &--completed {
    background: #eafaf1;
    border-color: #b8ecd1;
    color: #1f9b54;

    &:hover {
      border-color: #7fd4a0;
    }

    &.is-active {
      background: #eafaf1;
      border-color: #2bc275;
      box-shadow: 0 0 0 2px rgba(43, 194, 117, 0.15);
    }
  }

  &--current {
    background: #fff;
    border-color: #7366ff;
    color: #4a3fd6;

    &:hover {
      background: #f0efff;
    }

    &.is-active {
      background: #4a3fd6;
      border-color: #4a3fd6;
      color: #fff;
    }
  }

  &--waiting {
    background: #f8f9fa;
    border-color: #e6e8ef;
    color: #adb1bc;

    &:hover {
      border-color: #cfd3dc;
      color: #6b6f7c;
    }

    &.is-active {
      background: #f1f2f6;
      border-color: #adb1bc;
      color: #6b6f7c;
    }
  }

  &--not_needed {
    background: #f8f9fa;
    border-color: #e6e8ef;
    color: #6b6f7c;

    &:hover {
      border-color: #cfd3dc;
    }

    &.is-active {
      background: #f1f2f6;
      border-color: #adb1bc;
    }
  }
}
</style>
